import { decryptV3H5, decryptV3App, isInApp, } from '@docs/common'
import { omit } from 'lodash';
import { AxiosResponse } from 'axios';
import { getEcdhKeyLocalStorage } from '../../utils/secure';

export const handleV3Response = async (response: AxiosResponse<any>, domain?: string) => {
  let _data = response.data || {}
  // 如果是在app 调用app的解密方法
  if (await isInApp()) {
    if (typeof _data === 'string') {
      _data = await decryptV3App({ type: 0, data: _data, domain: domain || '' })
    } else if (typeof _data?.data === 'string') {
      _data = {
        ...omit(_data, ['data']),
        data: await decryptV3App({ type: 0, data: _data.data, domain: domain || '' }),
      }
    }
  } else {
    // 如果是在h5 调用h5的解密方法
    const ecdhKey = await getEcdhKeyLocalStorage()
    if (typeof _data === 'string') {
      _data = await decryptV3H5(_data, ecdhKey.shareKey)
    } else if (typeof _data?.data === 'string') {
      _data = {
        ...omit(_data, ['data']),
        data: await decryptV3H5(_data.data, ecdhKey.shareKey),
      }
    }
  }

  return _data
}